import useApi from '@/lib/api/useApi';
import { Button } from '@mui/material';
import { useContext, useState } from 'react';
import { TipsAndUpdatesOutlined as TipsAndUpdatesIcon } from '@mui/icons-material';
import ModelsContext from '../ModelsContext';
import ModelType from '@/lib/constants/challengeModel/ModelType.enum';
import { type EditorModelWithoutRelations } from '@/lib/types';
import CreateContentWrapper from './CreateContentWrapper';
import { FormattedMessage } from 'react-intl';
import FormattedMessageWithChallengeNaming from '@/components/FormattedMessageWithChallengeNaming';

type DefaultModelsResponse = {
  [ModelType.CHALLENGE]: EditorModelWithoutRelations;
  [ModelType.TASK]: EditorModelWithoutRelations;
};

const CreateDefaultModels = () => {
  const api = useApi();

  const [, setModels] = useContext(ModelsContext);
  const [creating, setCreating] = useState(false);

  const createDefaultModels = async (): Promise<void> => {
    setCreating(true);

    const defaultModels = await api.post<DefaultModelsResponse>(
      'editor/challenge-model/models/create-default',
    );

    const defaultChallengeModel = defaultModels[ModelType.CHALLENGE];
    const defaultTaskModel = defaultModels[ModelType.TASK];

    setModels(models => {
      models[defaultChallengeModel.id] = {
        ...defaultChallengeModel,
        sections: {},
        fields: {},
      };

      models[defaultTaskModel.id] = {
        ...defaultTaskModel,
        sections: {},
        fields: {},
      };
    });

    setCreating(false);
  };

  return (
    <CreateContentWrapper>
      <h1>
        <TipsAndUpdatesIcon />
        <FormattedMessage id="editor.model_editor.create_default_models.title" />
      </h1>
      <p>
        <FormattedMessageWithChallengeNaming id="editor.model_editor.create_default_models.text" />
      </p>
      <Button
        variant="contained"
        onClick={createDefaultModels}
        loadingPosition="start"
        loading={creating}
        disableElevation
      >
        <FormattedMessage
          id={`editor.model_editor.create_default_models.setup_button${creating ? '.loading' : ''}`}
        />
      </Button>
    </CreateContentWrapper>
  );
};

export default CreateDefaultModels;
